import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useProfile } from "@/hooks/useProfile";

export interface StayActivityType {
  id: string;
  name: string;
  color: string | null;
  icon: string | null;
  sortOrder: number;
}

export const stayActivityTypesKey = (clinicId: string | null) => ["stay-activity-types", clinicId];

export function useStayActivityTypes() {
  const { data: profile } = useProfile();
  const clinicId = profile?.current_clinic_id ?? null;
  return useQuery({
    queryKey: stayActivityTypesKey(clinicId),
    enabled: !!clinicId,
    queryFn: async (): Promise<StayActivityType[]> => {
      if (!clinicId) return [];
      const { data, error } = await supabase
        .from("stay_activity_types")
        .select("id, name, color, icon, sort_order")
        .eq("clinic_id", clinicId)
        .eq("is_active", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data ?? []).map((t) => ({ id: t.id, name: t.name, color: t.color, icon: t.icon, sortOrder: t.sort_order }));
    },
  });
}
